<template>
    <ais-search-box>
        <div
            slot-scope="{ currentRefinement, refine }"
        >
            <input
                v-model="currentRefinement"
                type="search"
                @input="refine($event.currentTarget.value)"
            >
        </div>
    </ais-search-box>
</template>
<script>
export default {
    name: 'AlgoliaSearchBar'
}
</script>
<style lang="scss" scoped>
    input {
        padding: 0.5rem 0;
        border: 0;
        background: transparent;
        border-bottom: 2px solid $action-color;
        border-radius: 2px;
        font-size: 1rem;
        width: 100%;
        color: $base-font-color;
        font-family: $base-font-family;
    }
</style>
